var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63867 0.742432C4.22267 0.742432 0.638672 4.32643 0.638672 8.74243C0.638672 13.1584 4.22267 16.7424 8.63867 16.7424C13.0547 16.7424 16.6387 13.1584 16.6387 8.74243C16.6387 4.32643 13.0547 0.742432 8.63867 0.742432ZM6.47067 12.1744L3.59867 9.30243C3.28667 8.99043 3.28667 8.48643 3.59867 8.17443C3.91067 7.86243 4.41467 7.86243 4.72667 8.17443L7.03867 10.4784L12.5427 4.97443C12.8547 4.66243 13.3587 4.66243 13.6707 4.97443C13.9827 5.28643 13.9827 5.79043 13.6707 6.10243L7.59867 12.1744C7.29467 12.4864 6.78267 12.4864 6.47067 12.1744Z",
    fill: "#2898A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.849ff3c5e8a9fae331eadeb83d1ffa12.svg";
export { ForwardRef as ReactComponent };